import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=5d142e72"
import script from "./PrivacyPolicy.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrivacyPolicy.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=5d142e72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports